
@switch (shape) {
  @case (StatusShape.Circle) {
    <svg width="32" height="32" viewBox="0 0 32 32" (click)="onPlacemarkClick()">
      <circle class="shape" cx="16" cy="16" r="12" [attr.fill]="bgColor"/>
      <text x="16" y="16" text-anchor="middle" alignment-baseline="middle" [attr.fill]="textColor" font-size="10">{{ label }}</text>
    </svg>
  }
  @case (StatusShape.Square) {
    <svg width="32" height="32" viewBox="0 0 32 32" (click)="onPlacemarkClick()">
      <rect class="shape" x="6" y="6" width="20" height="20" [attr.fill]="bgColor"/>
      <text x="16" y="16" text-anchor="middle" alignment-baseline="middle" [attr.fill]="textColor" font-size="10">{{ label }}</text>
    </svg>
  }
  @case (StatusShape.Triangle) {
    <svg width="32" height="32" viewBox="0 0 32 32" (click)="onPlacemarkClick()">
      <polygon class="shape" points="16,6 26,26 6,26" [attr.fill]="bgColor"/>
      <text x="16" y="20" text-anchor="middle" alignment-baseline="middle" [attr.fill]="textColor" font-size="10">{{ label }}</text>
    </svg>
  }
}
